// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Firestore import 추가
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBxfufO17URasdNShlC7-Oz7DZyjUvkepI",
  authDomain: "omniscient-readers-viewp-1b64c.firebaseapp.com",
  projectId: "omniscient-readers-viewp-1b64c",
  storageBucket: "omniscient-readers-viewp-1b64c.firebasestorage.app",
  messagingSenderId: "304183322270",
  appId: "1:304183322270:web:8012caec66c307cd0f7d8f",
  measurementId: "G-M6XCC6NX71"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app); // Firestore 인스턴스 export
export const funnelDb = getFirestore(app, 'funnel-data'); // funnel-data 데이터베이스 인스턴스 export